module.exports = __webpack_public_path__ + "img/mov.0ad1aa9e.svg";